import Experience from '../Experience.js'
import Environment from './Environment.js'
import Mario from './Mario.js'
import Floor from './Floor.js'
import Cloud from './Cloud.js'
import Dice from './Dice.js'

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.camera = this.experience.camera

        this.shouldPlay = false

        // Wait for resources
        this.resources.on('ready', () =>
        {
            // Setup
            this.floor = new Floor()
            this.cloud1 = new Cloud()
            this.cloud1.setPosition(-1, 2, -3)
            this.cloud2 = new Cloud()
            this.cloud2.setPosition(3, 2, -4)
            this.cloud3 = new Cloud()
            this.cloud3.setPosition(1, 2.5, -2)
            this.cloud4 = new Cloud()
            this.cloud4.setPosition(-3, 3, -6)
            this.dice = new Dice()
            this.environment = new Environment()
            this.mario = new Mario()
            this.experience.camera.controls.target = this.mario.mesh.position
            this.experience.camera.instance.position.set(0, 1, 5)
            this.$btn = document.getElementById('playBtn')
            this.audio = new Audio('/music.mp3')
            if (this.$btn) {
                this.$btn.addEventListener('click', () => this.btnClick())
            }
            document.addEventListener('keypress', (evt) => {
                if(evt.code === 'Space' && document.activeElement != this.$btn) this.btnClick()
            })
        })
    }

    btnClick() {
        this.shouldPlay = !this.shouldPlay
        this.$btn.classList.toggle('playing', this.shouldPlay)
        if (this.shouldPlay) {
            this.audio.play()
        } else {
            this.audio.pause()
        }
    }

    update(time)
    {
        if (this.shouldPlay) {
            if(this.dice)
                this.dice.update(time)
            if(this.mario)
                this.mario.update(time)
        }
        if(this.cloud1)
            this.cloud1.update(time)
        if(this.cloud2)
            this.cloud2.update(time)
        if(this.cloud3)
            this.cloud3.update(time)
    }
}